export const REFRESH = "REFRESH";
export const SIGNOUT = "SIGNOUT";
export const NEW_NOTIFICATION = "NEW_NOTIFICATION";
export const FETCH_NOTIFICATION = "FETCH_NOTIFICATION";
